"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetTransactionPwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPassword_1 = require("../../model/hsPassword");
var service_1 = require("../../../library/base/service");
var ResetTransactionPwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ResetTransactionPwd, _super);
    function ResetTransactionPwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '重置登陆密码接口';
        _this.code = '105017';
        _this.desc = '重置登陆密码接口';
        _this.requestParams = new hsPassword_1.ResetTransactionPwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ResetTransactionPwd;
}(service_1.BaseService));
exports.ResetTransactionPwd = ResetTransactionPwd;
//# sourceMappingURL=resetTransactionPwd.js.map